import {useMerchantStore} from '@src/store/merchant'
import {Context} from '@src/utility/sentry/type'
import {storageAvailable} from '@src/utility/storageFactory'
import {detectIncognito} from 'detect-incognito'

let isPrivate: boolean | null = null
detectIncognito()
  .then(result => (isPrivate = result.isPrivate))
  .catch(() => null)

type ContextWithTags = Extract<Context, {tags?: Record<string, unknown>}>

export const makeContext = (context: Context): Context => {
  const existingTags = (context as ContextWithTags)?.tags
  return {
    ...(context as Record<string, unknown>),
    tags: {
      ...existingTags,
      business_corporate_name: useMerchantStore?.getState()?.input?.business_corporate_name,
      isPrivate,
      sentryTunnel: true,
      storage: storageAvailable(),
      username: useMerchantStore?.getState()?.input?.email
    }
  } as Context
}

export const isNetworkError = (message: unknown): boolean => {
  let result = false
  if (message && typeof message === 'string') {
    result = networkErrorsList.includes(
      message?.toString()?.replace('TypeError: ', '')?.replace('Error: ', '')?.toLowerCase()?.trim()
    )
  }
  return result
}

export const sentryLinkConfig = {
  attachBreadcrumbs: {
    includeError: true,
    includeFetchResult: true,
    includeVariables: true
  },
  setFingerprint: false,
  setTransaction: false
}

const networkErrorsList = [
  'load failed',
  'failed to fetch',
  'cancelado',
  'cancelled',
  'the network connection was lost',
  'the network connection was lost.',
  'a conexão de rede foi perdida',
  'a conexão de rede foi perdida.',
  'networkerror when attempting to fetch resource.',
  'networkerror when attempting to fetch resource',
  'client timeout',
  'network connection error'
]

export const maskDeep = (input: unknown, keys: string[]): unknown => {
  if (Array.isArray(input)) return input.map(i => maskDeep(i, keys))

  if (input && typeof input === 'object' && !(input instanceof Function)) {
    const rv: Record<string, unknown> = {}
    Object.entries(input).forEach(([k, v]) => {
      return (rv[k] = keys.reduce((matched, key) => k.toLowerCase().includes(key.toLowerCase()) || matched, false)
        ? '*****'
        : maskDeep(v, keys))
    })
    return rv
  }

  if (input && typeof input === 'string') {
    let json
    try {
      json = JSON.parse(input)
    } catch (e) {
      return input
    }
    return JSON.stringify(maskDeep(json, keys))
  }

  return input
}
